<div class="loading-screen" [@fadeOut]="isVisible ? 'visible' : 'hidden'">
  <div class="loading-content" [@scaleIn]>
    <div class="logo-container">
      <div class="spinner">
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
        <div class="spinner-ring"></div>
      </div>
      <div class="logo-icon">
        <i class="fas fa-leaf"></i>
      </div>
    </div>
    <h1 class="loading-title">Greenwashing Risk Dashboard</h1>
    <div class="loading-dots">
      <span class="dot"></span>
      <span class="dot"></span>
      <span class="dot"></span>
    </div>
    <p class="loading-text">Analysing ESG data...</p>
  </div>
  <div class="loading-background">
    <div class="wave wave1"></div>
    <div class="wave wave2"></div>
    <div class="wave wave3"></div>
  </div>
</div>

